import SeoHead from "@/components/SeoHead";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { Link } from "react-router-dom";
import LocalFaqSection from "./components/LocalFaqSection";

const localServices = [
  {
    icon: "ri-home-4-line",
    title: "Pose de carrelage à Vercorin",
    desc: "Pose de carrelage à Vercorin. On s'adapte aux petites surfaces des chalets et maisons villageoises, avec des matériaux qui respectent l'esprit du lieu.",
  },
  {
    icon: "ri-drop-line",
    title: "Rénovation salle de bain à Vercorin",
    desc: "Rénovation de salle de bain à Vercorin. On modernise les installations tout en respectant l'âme des vieilles bâtisses. Pierre naturelle, bois, carrelage rustique.",
  },
  {
    icon: "ri-water-flash-line",
    title: "Douche italienne à Vercorin",
    desc: "Douche italienne à Vercorin. Une solution pratique dans les espaces compacts des maisons de montagne. Receveur encastré, pente au millimètre.",
  },
  {
    icon: "ri-layout-grid-line",
    title: "Faïence & mosaïque à Vercorin",
    desc: "Faïence et mosaïque à Vercorin. Des créations qui s'intègrent dans l'ambiance créative du village. Chaque pose est unique, comme la maison qu'elle habille.",
  },
  {
    icon: "ri-sun-line",
    title: "Carrelage extérieur à Vercorin",
    desc: "Terrasses et allées à Vercorin. Carrelage antidérapant résistant au gel, avec une esthétique discrète qui ne trahit pas le paysage montagnard.",
  },
];


const breadcrumbSchema = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": [
    {
      "@type": "ListItem",
      "position": 1,
      "name": "Accueil",
      "item": "https://carreaux-bat.ch/"
    },
    {
      "@type": "ListItem",
      "position": 2,
      "name": "Vercorin",
      "item": "https://carreaux-bat.ch/vercorin"
    }
  ]
};

const webPageSchema = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": "Carrelage et Rénovation à Vercorin, Valais",
  "description": "Pose de carrelage artisanal et rénovation de salle de bain à Vercorin, Village de Peintres. Pierre naturelle, mosaïque, douche italienne en authentique village montagnard.",
  "url": "https://carreaux-bat.ch/vercorin",
  "mainEntity": {
    "@type": "LocalBusiness",
    "name": "Carreaux-Bat Valais",
    "telephone": "+41 77 511 75 52",
    "areaServed": {
      "@type": "City",
      "name": "Vercorin",
      "containedInPlace": {
        "@type": "AdministrativeArea",
        "name": "Valais"
      }
    }
  }
};

export default function VercorinPage() {
  return (
    <div className="min-h-screen">
      <SeoHead
        title="Entreprise de Carrelage & Carreleur à Vercorin à Proximité | Village de Peintres Valais"
        description="Vous cherchez un carreleur à proximité de Vercorin ? Entreprise de carrelage et société de carrelage à Vercorin, Village de Peintres, Valais. Service de carrelage artisanal par carreleur près de chez vous à Vercorin. Pierre naturelle, terre cuite, mosaïque artisanale, douche italienne. Devis gratuit."
        keywords="carreleur à proximité de Vercorin, entreprise de carrelage à proximité de Vercorin, société de carrelage à proximité de Vercorin, carreleur près de chez moi Vercorin, entreprise de carrelage près de chez vous Vercorin, service de carrelage à proximité Vercorin, entreprise de carrelage Vercorin, société de carrelage Vercorin, service de carrelage Vercorin, carreleur Vercorin, pose de carrelage Vercorin, rénovation salle de bain Vercorin, douche italienne Vercorin, carrelage village montagne Valais, mosaïque artisanale Vercorin, artisan carreleur Valais central"
        canonical="https://carreaux-bat.ch/vercorin"
        ogTitle="Carrelage & Rénovation à Vercorin à Proximité — Artisan Carreleur en Village de Peintres"
        ogDescription="Vous cherchez un carreleur à proximité de Vercorin ? Pose de carrelage artisanal, rénovation salle de bain et douche italienne à Vercorin. Matériaux naturels et créations qui respectent l'âme du village."
        ogImage="/images/vercorin-hero.jpg"
        geoPosition="46.2833;7.5333"
        geoPlacename="Vercorin, Valais, Suisse"
        geoRegion="CH-VS"
      schema={{
        "@context": "https://schema.org",
        "@graph": [webPageSchema, breadcrumbSchema]
      }}
      />
      <Navbar />

      {/* Hero */}
      <section className="relative pt-32 pb-20 overflow-hidden">
        <img
          src="/images/vercorin-hero.jpg"
          alt="Carrelage Vercorin Valais"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/70"></div>
        <div className="relative z-10 max-w-7xl mx-auto px-6 text-center">
          <span className="inline-block mb-4 px-4 py-1.5 bg-amber-700/80 text-white text-xs font-medium tracking-widest uppercase rounded-full">
            Village de Peintres
          </span>
          <h1 className="text-5xl font-bold text-white mb-4">Entreprise de Carrelage & Carreleur à Vercorin</h1>
          <p className="text-white/70 max-w-xl mx-auto text-sm leading-relaxed">
            Artisan carreleur à Vercorin — pose de carrelage, rénovation de salle de bain et aménagement intérieur avec le souci de l&apos;authenticité montagnarde.
          </p>
          <div className="flex items-center justify-center gap-2 mt-6 text-sm text-white/50">
            <Link to="/" className="hover:text-amber-400 transition-colors">Accueil</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-white">Vercorin</span>
          </div>
        </div>
      </section>

      {/* Description longue */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
            <div>
              <span className="text-xs uppercase tracking-widest text-amber-700 font-medium">Vercorin, Valais</span>
              <h2 className="mt-2 text-3xl font-bold text-stone-900 mb-6">Vercorin, village d&apos;artistes et d&apos;artisans</h2>
              <div className="space-y-4 text-sm text-stone-500 leading-relaxed">
                <p>
                  Vercorin est un village de montagne d&apos;environ 500 habitants, perché à 1 300 mètres d&apos;altitude sur les hauteurs de la vallée du Rhône, dans le district de Sierre. Surnommé le &quot;Village de Peintres&quot;, Vercorin est devenu au fil des décennies un refuge pour artistes, artisans et créateurs qui ont transformé ce petit bourg en un lieu unique de créativité et d&apos;authenticité.
                </p>
                <h3 className="text-lg font-bold text-stone-800 mt-6 mb-2">Carreleur à Vercorin — Pose de carrelage artisanal en pierre naturelle</h3>
                <p>
                  Ce qui distingue Vercorin est son centre villageois entièrement piétonnier, une rareté en Valais. Les ruelles pavées, les fontaines anciennes, les ateliers d&apos;artistes et les maisons traditionnelles en pierre et bois créent une atmosphère hors du temps qui séduit les visiteurs en quête de calme et de charme authentique. Le village est entouré de forêts de mélèzes et offre une vue splendide sur les Alpes valaisannes et le massif du Mont-Blanc à l&apos;horizon.
                </p>
                <p>
                  Vercorin est également une station de ski familiale qui fait partie du domaine de la Vallée de la Sienne. Les pistes, adaptées aux familles et aux débutants, offrent un cadre convivial loin de la foule des grandes stations. En été, le village est un point de départ privilégié pour de nombreuses randonnées, dont le célèbre sentier qui mène à la Bisse de Clavau par les hauteurs.
                </p>
                <h3 className="text-lg font-bold text-stone-800 mt-6 mb-2">Entreprise de carrelage à Vercorin — Rénovation salle de bain et mosaïque artisanale</h3>
                <p>
                  L&apos;immobilier à Vercorin se compose principalement de maisons villageoises anciennes, de chalets traditionnels et de quelques résidences récentes. Beaucoup de propriétaires sont des amoureux du patrimoine qui souhaitent rénover leur bien en respectant l&apos;identité architecturale locale. Les salles de bain et les cuisines nécessitent une attention particulière pour allier confort moderne et esthétique montagnarde authentique.
                </p>
                <h3 className="text-lg font-bold text-stone-800 mt-6 mb-2">Service de carrelage à Vercorin — Terre cuite et mosaïque artisanale</h3>
                <p>
                  Notre équipe intervient à Vercorin avec le respect de l&apos;identité du village. On propose des solutions de carrelage qui s&apos;intègrent dans l&apos;ambiance rustique et artistique du lieu : pierres naturelles, terres cuites, mosaïques artisanales. On connaît les accès en montagne et les contraintes des vieilles bâtisses, et on livre un boulot solide même quand c&apos;est compliqué. Envoyez-nous un message pour votre projet à Vercorin.
                </p>
              </div>
            </div>
            <div>
              <div className="relative rounded-lg overflow-hidden h-96 mb-6">
                <img
                  src="/images/vercorin-realisation.jpg"
                  alt="Réalisation carrelage Vercorin"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div className="bg-amber-50 rounded-lg p-5 border border-amber-100">
                  <p className="text-2xl font-bold text-amber-700">500</p>
                  <p className="text-xs text-stone-500 mt-1">Habitants à Vercorin</p>
                </div>
                <div className="bg-stone-50 rounded-lg p-5 border border-stone-100">
                  <p className="text-2xl font-bold text-stone-900">1300 m</p>
                  <p className="text-xs text-stone-500 mt-1">Altitude</p>
                </div>
                <div className="bg-stone-50 rounded-lg p-5 border border-stone-100">
                  <p className="text-2xl font-bold text-stone-900">48h</p>
                  <p className="text-xs text-stone-500 mt-1">Délai d&apos;intervention</p>
                </div>
                <div className="bg-amber-50 rounded-lg p-5 border border-amber-100">
                  <p className="text-2xl font-bold text-amber-700">Gratuit</p>
                  <p className="text-xs text-stone-500 mt-1">Devis sur place</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services locaux */}
      <section className="py-20 bg-stone-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <span className="text-xs uppercase tracking-widest text-amber-700 font-medium">Prestations locales</span>
            <h2 className="mt-3 text-3xl font-bold text-stone-900">Nos services à Vercorin</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {localServices.map((service) => (
              <div key={service.title} className="bg-white rounded-lg p-6 border border-stone-100 hover:border-amber-200 transition-colors">
                <div className="w-11 h-11 flex items-center justify-center bg-amber-50 rounded-lg mb-4">
                  <i className={`${service.icon} text-amber-700 text-xl`}></i>
                </div>
                <h3 className="text-base font-semibold text-stone-900 mb-2">{service.title}</h3>
                <p className="text-sm text-stone-500 leading-relaxed">{service.desc}</p>
              </div>
            ))}
            <div className="bg-amber-700 rounded-lg p-6 flex flex-col justify-between">
              <div>
                <h3 className="text-base font-semibold text-white mb-2">Devis gratuit à Vercorin</h3>
                <p className="text-sm text-amber-100 leading-relaxed">Envoyez-nous un message, on monte à Vercorin avec le matériel adapté. On regarde votre espace, on discute, et on vous dit franchement ce qu'on peut faire.</p>
              </div>
              <Link
                to="/contact"
                className="mt-6 inline-flex items-center gap-2 px-5 py-2.5 bg-white text-amber-700 text-sm font-medium rounded-full hover:bg-amber-50 transition-colors whitespace-nowrap"
              >
                Demander un devis
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Contact CTA */}
      <section className="py-16 bg-stone-900">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-3xl font-bold text-white mb-4">Votre projet à Vercorin</h2>
          <p className="text-stone-400 text-sm mb-8 max-w-xl mx-auto">
            Artisan carreleur basé en Valais, nous intervenons à Vercorin avec le respect de l&apos;authenticité du village. Devis gratuit, travail artisanal soigné.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/contact"
              className="px-8 py-3.5 bg-amber-700 text-white font-medium rounded-full hover:bg-amber-600 transition-colors whitespace-nowrap"
            >
              Devis gratuit à Vercorin
            </Link>
            <a
              href="tel:+41775117552"
              className="px-8 py-3.5 border border-stone-600 text-stone-300 font-medium rounded-full hover:border-amber-600 hover:text-amber-400 transition-colors whitespace-nowrap flex items-center justify-center gap-2"
            >
              <i className="ri-phone-line"></i>
              +41 77 511 75 52
            </a>
          </div>
        </div>
      </section>

      <LocalFaqSection
        city="Vercorin"
        faqs={[
          {
            question: "Proposez-vous des matériaux qui s'intègrent dans l'esprit du Village de Peintres ?",
            answer: "Oui, c'est notre approche à Vercorin. On propose des pierres naturelles, des terres cuites, des mosaïques artisanales et des matériaux chaleureux qui s'intègrent dans l'ambiance rustique et créative du village. Chaque projet est unique et respecte l'identité du lieu."
          },
          {
            question: "Comment travaillez-vous dans les vieilles maisons villageoises de Vercorin ?",
            answer: "Les vieilles maisons de Vercorin ont des sols en terre battue ou en vieux bois, et des murs en pierre. On adapte chaque pose : ragréage spécifique, matériaux qui respirent, et techniques de pose adaptées aux supports anciens. On préserve le charme tout en apportant le confort moderne."
          },
          {
            question: "Quels matériaux recommandez-vous pour les intérieurs montagnards ?",
            answer: "Pour Vercorin, on recommande des matériaux chaleureux et naturels : pierre de travertin, terre cuite patinée, carrelage imitation bois en grès cérame, et mosaïques artisanales. Ces matériaux apportent de la chaleur aux intérieurs et résistent parfaitement au climat de montagne."
          },
          {
            question: "Faites-vous des terrasses avec vue sur les Alpes ?",
            answer: "Oui, on réalise des terrasses à Vercorin avec des carrelages antidérapants et résistants au gel, choisis pour leur esthétique discrète qui ne dénature pas le paysage. On prend en compte la pente, l'écoulement des eaux, et la résistance aux UV pour un résultat durable et esthétique."
          },
          {
            question: "Intervenez-vous dans le centre piétonnier de Vercorin ?",
            answer: "Oui, on connaît les contraintes du centre piétonnier. On planifie les livraisons et le transport du matériel en amont pour minimiser les perturbations. On travaille propre et discret, en respectant la tranquillité du village et de ses habitants."
          },
          {
            question: "Quel est le prix d'une rénovation artisanale à Vercorin ?",
            answer: "Le prix varie selon la surface, les matériaux choisis et la complexité du chantier. À Vercorin, les vieilles bâtisses peuvent nécessiter des préparations spécifiques qui influencent le coût. On fait un devis gratuit et détaillé sur place, avec toutes les lignes de postes transparentes."
          }
        ]}
      />

      <Footer />
    </div>
  );
}
